import { z } from "zod";
export const messageReceivedFromExtensionSchema = z
    .object({
    type: z.literal('RUN_CADENCES_STARTED'),
    data: z.object({ tabId: z.number().optional(), nextCadenceIds: z.array(z.string()).optional() }).optional(),
})
    .or(z.object({ type: z.literal('RUN_CADENCES_STOPPED') }))
    .or(z.object({
    type: z.literal('RUN_STEPS_STARTED'),
    data: z.object({ tabId: z.number().optional() }).optional(),
}))
    .or(z.object({ type: z.literal('CONNECT_AWK') }))
    .or(z.object({ type: z.literal('CHECK_MESSAGES') }))
    .or(z.object({ type: z.literal('CHECK_SALES_NAV_MESSAGES') }))
    .or(z.object({ type: z.literal('CHECK_CONNECTIONS') }))
    .or(z.object({ type: z.literal('CHECK_SENT_INVITATIONS') }))
    .or(z.object({ type: z.literal('RUN_STEP_FINISHED') }))
    .or(z.object({ type: z.literal('RUN_CADENCE_FINISHED') }))
    .or(z.object({
    type: z.literal('RUN_CADENCE'),
    data: z.object({
        id: z.string(),
        explicitCadenceIds: z.array(z.string()).optional(),
    }),
}))
    .or(z.object({
    type: z.literal('RUN_STEP'),
    data: z.object({
        id: z.string(),
    }),
}))
    .or(z.object({
    type: z.literal('ERROR'),
    data: z.object({
        action: z.string(),
        code: z.string(),
        contactId: z.string(),
        message: z.string(),
    }),
}));
